
import VueJSModal from 'vue-js-modal'
import eventBus from '../../plugins/eventBus'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

Vue.use(VueJSModal)

@Component({})
export default class CreditModal extends Vue {
  @Prop()
  details: any

  closeModal() {
    this.$modal.hide('credits-details')
  }
}
